'use client'

import { LinkItem } from '@/app/_components/layout/LinkItem'
// TODO: CanadaGoose確認待ちのため一時的にコメントアウト (Allbirds先行リリース対応)
// import { NewsletterForm } from '@/app/_components/newsletter/newsletter-form'
import { usePreOpen } from '@/hooks/usePreOpen'
import Image from 'next/image'

export function Footer() {
  const { isPreOpen } = usePreOpen()

  return (
    <footer
      id="footer"
      className="bg-primary text-white pt-16 pb-5 px-10 lg:pt-[72px] lg:pb-[35px] lg:px-[70px]"
    >
      <div className="flex flex-col lg:flex-row lg:justify-between mb-16 md:mb-[64px] pb-16 md:pb-[64px] border-b border-white/20 gap-y-7 lg:gap-y-0">
        <div className="flex flex-col md:flex-row">
          {/* お買い物と下取りのエリア */}
          {isPreOpen && (
            <div className="flex gap-x-[20%] md:gap-x-5 lg:gap-x-[70px] md:mr-5 lg:mr-[70px] mb-7 md:mb-0">
              <div className="flex flex-col gap-y-2">
                <p className="font-bold text-sm mb-4">お買い物をする</p>
                <LinkItem
                  href="/listings?gender=1"
                  text="ウィメンズ"
                  className="text-xs w-fit font-medium"
                />
                <LinkItem
                  href="/listings?gender=0"
                  text="メンズ"
                  className="text-xs w-fit font-medium"
                />
                <LinkItem
                  href="/listings?gender=2"
                  text="キッズ"
                  className="text-xs w-fit font-medium"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <p className="font-bold text-sm mb-4">下取りに出す</p>
                <LinkItem
                  href="/tradein"
                  text="下取りに出す方法"
                  className="text-xs w-fit font-medium"
                />
                <LinkItem
                  href="/tradein/search"
                  text="下取り申請"
                  className="text-xs w-fit font-medium"
                />
              </div>
            </div>
          )}

          {/* GenerationsとABOUTのエリア */}
          <div className="flex flex-col md:flex-row md:gap-x-5 lg:gap-x-[70px] gap-y-7 md:gap-y-0">
            <div className="flex flex-col gap-y-2">
              <p className="font-bold text-sm mb-4">
                CANADA GOOSE Generationsについて
              </p>
              <LinkItem
                href="/faq"
                text="よくあるご質問"
                className="text-xs w-fit font-medium"
              />
              <LinkItem
                href="/payment"
                text="お支払いについて"
                className="text-xs w-fit font-medium"
              />
              {/*　TODO: 本リリース時に isPreOpen 削除　*/}
              {isPreOpen && (
                <LinkItem
                  href="/return"
                  text="返品・交換について"
                  className="text-xs w-fit font-medium"
                />
              )}
              <LinkItem
                href="/shipping"
                text="配送について"
                className="text-xs w-fit font-medium"
              />
              <LinkItem
                href="/pricing"
                text="販売価格・送料・決済手数料について"
                className="text-xs w-fit font-medium"
              />
              <LinkItem
                href="/contact"
                text="お問い合わせ"
                className="text-xs w-fit font-medium"
              />
              <LinkItem
                href="/terms"
                text="ご利用規約"
                className="text-xs w-fit font-medium"
              />
            </div>
            <div className="flex flex-col gap-y-2">
              <p className="font-bold text-sm mb-4">カナダグースについて</p>
              <LinkItem
                href="https://www.canadagoose.jp/our-history/?srsltid=AfmBOoo31VJ8mAxKzuW_ks50tHU8e6JP5OazDmqQiL5igxQBntM2EoA2"
                text="ヒストリー"
                className="text-xs w-fit font-medium"
                target="_blank"
              />
              <LinkItem
                href="https://www.canadagoose.jp/HUMANATURE/?srsltid=AfmBOoqvIgMCUZ_jCDv-gQG3mVlO81iSOuOseHvz4snPIA4FL-l3hBGC"
                text="サステナビリティ"
                className="text-xs w-fit font-medium"
                target="_blank"
              />
              <LinkItem
                href="https://www.canadagoose.jp"
                text="カナダグース日本公式サイト"
                className="text-xs w-fit font-medium"
                target="_blank"
              />
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        {/* TODO: CanadaGoose確認待ちのため一時的にコメントアウト (Allbirds先行リリース対応) */}
        {/* <div className="lg:ml-[70px] lg:min-w-[400px] lg:max-w-[500px]">
          <NewsletterForm />
        </div> */}
      </div>

      <div className="flex justify-center items-center flex-col md:flex-row mt-16 md:mt-[64px] gap-y-3 md:gap-y-0">
        {/* pc表示 */}
        <div className="hidden lg:flex items-center gap-x-11">
          <Image
            src="/canada_goose_logo.png"
            alt="Canada Goose"
            width="44"
            height="44"
          />
          <small className="text-xs">
            Copyright ⓒ CANADA GOOSE JAPAN, K.K.
          </small>
          <span>|</span>
          <div className="flex items-center gap-x-11">
            <LinkItem
              href="/privacy"
              text="個人情報保護方針"
              className="text-xs w-fit font-medium"
            />
            <LinkItem
              href="/legal"
              text="特定商取引法に基づく表記・古物営業表に基づく表記"
              className="text-xs w-fit font-medium"
            />
          </div>
        </div>
        {/* sp表示 */}
        <div className="flex flex-col lg:hidden items-center gap-6">
          <LinkItem
            href="/privacy"
            text="個人情報保護方針"
            className="text-xs w-fit font-medium"
          />
          <LinkItem
            href="/legal"
            text="特定商取引法に基づく表記・古物営業表に基づく表記"
            className="text-xs w-fit font-medium"
          />
          <small className="text-[10px]">
            Copyright ⓒ CANADA GOOSE JAPAN, K.K.
          </small>
          <Image
            src="/canada_goose_logo.png"
            alt="Canada Goose"
            width="44"
            height="44"
          />
        </div>
      </div>
    </footer>
  )
}
